<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ganancias</b>
            <button
              @click="mtdBack"
              type="button"
              class="btn btn-sm text-white"
              style="background: #e46666"
            >
              <i class="fas fa-hand-point-left"></i> Retroceder
            </button>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol
                xs="12"
                sm="12"
                md="12"
                lg="12"
                v-if="$store.getters.get_rol.id !== 7"
              >
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="onCampusChange"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput
                  label="Desde"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  size="sm"
                  id="init"
                  v-model="filter.init"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput
                  label="Hasta"
                  type="date"
                  aria-label="shift_date"
                  @input="mtd_data"
                  id="end"
                  size="sm"
                  v-model="filter.end"
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput
                  label="Cantidad de registros de Ganancia"
                  type="text"
                  size="sm"
                  v-model="countProfit"
                  disabled
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                <CInput
                  label="Monto Total de ganancias"
                  type="text"
                  size="sm"
                  v-model="sumaProfit"
                  disabled
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="8" lg="8" xl="9">
        <CCard>
          <CCardHeader>
            <b
              ><i class="fas fa-chart-line"></i>&nbsp;Gráfico de Ganancias por
              Sede</b
            >
          </CCardHeader>
          <CCardBody style="height: 370px; position: relative">
            <CChartBar
              class="h-100"
              :datasets="profitDatasets"
              :options="chartOptions"
              :labels="campusLabels"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import { hexToRgba } from "@coreui/utils/src";
import { mapActions } from "vuex";
import moment from "moment";

const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "date_formatted", label: "Fecha", _style: "width:5%;" },
  { key: "campu", label: "Sede", _style: "width:10%;" },
  { key: "document_name", label: "Documento", _style: "width:10%;" },
  { key: "nrm_document", label: "N° document", _style: "width:10%;" },
  { key: "detail_sale", label: "Productos", _style: "width:10%;" },
  { key: "quantity", label: "Cantidad", _style: "width:10%;" },
  { key: "price_sale", label: "Precio Venta", _style: "width:10%;" },
  { key: "price_purchase", label: "Precio Compra", _style: "width:10%;" },
  { key: "profit", label: "Ganancia", _style: "width:5%;" },
];

export default {
  components: {
    CChartBar,
  },
  data() {
    return {
      prefix: "utilities",
      fields,
      data: [],
      campus: [],
      countProfit: 0,
      sumaProfit: 0,
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      profitsByCampus: {},
      coloresSedes: {
        "sede-1": "#41B883",
        "sede-2": "#0a4d86",
        "sede-3": "#8527a4",
        "sede-4": "#08e1ca",
        "sede-5": "#DD4B18",
        "sede-6": "#ff9900",
        "sede-7": "#9966ff",
        "sede-8": "#3399cc",
        "sede-9": "#cc6633",
        "sede-10": "#669900",
      },
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      data_campus: [],
      campu_id: 0,
    };
  },
  computed: {
    campusLabels() {
      return this.campus.map((campus) => campus.name);
    },
    profitDatasets() {
      const campusProfits = {};

      this.campus.forEach((campus) => {
        campusProfits[campus.id] = 0;
      });

      this.data.forEach((item) => {
        const campusId = item.campu_id;
        const profit = parseFloat(item.profit);

        if (campusProfits[campusId] !== undefined) {
          campusProfits[campusId] += profit;
        }
      });

      const profitData = this.campus.map(
        (campus) => campusProfits[campus.id] || 0
      );

      const datasets = [
        {
          label: "Ganancias",
          backgroundColor: this.campus.map((campus, index) =>
            hexToRgba(this.getColorForCampus(index), 70)
          ),
          borderColor: this.campus.map((campus, index) =>
            this.getColorForCampus(index)
          ),
          borderWidth: 1,
          data: profitData,
        },
      ];

      return datasets;
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: true,
          position: "top",
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 6,
                callback: function (value) {
                  return value.toFixed(2);
                },
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          rectangle: {
            borderWidth: 2,
          },
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const value = dataset.data[tooltipItem.index];
              return `Ganancia: ${parseFloat(value).toFixed(2)}`;
            },
          },
        },
      };
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.getCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus.push({
            label: "Todos",
            value: 0,
          });

          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });

          if (this.$store.getters.get_rol.id !== 7) {
            this.campu_id = this.$store.getters.get_campu.id;
          }

          this.campus = response.data;

          this.mtd_data();
        }
      });
    },
    onCampusChange() {
      this.mtd_data();
    },
    mtd_data() {
      if (
        !this.filter.init ||
        !this.filter.end ||
        this.filter.init > this.filter.end
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona un rango de fechas válido.",
        });
        return;
      }

      let campu_id =
        this.$store.getters.get_rol.id == 7
          ? this.$store.getters.get_campu.id
          : this.campu_id;

      campu_id = campu_id === 0 ? null : campu_id;

      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/index",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: campu_id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          this.clearData();
          let formattedData = [];
          let totalProfit = 0;

          this.data = response.data.sale;

          this.data.forEach((item) => {
            const formattedDate = moment(item.date).format("DD/MM/YYYY");
            item.date_formatted = formattedDate;

            const campusId = item.campu_id;
            const campusName = item.campu.name;
            item.campu = campusName;

            // item.document_name = item.document_type.name;
            // item.nrm_document = item.serie + "-" + item.number;
            item.detail.forEach((det) => {
              // const productProfit = det.product
              //     ? ((det.price - det.purchase_price) * det.quantity).toFixed(2)
              //     : 0;

              let adjustedPrice = parseFloat(det.price);
              let productProfit = det.product
                ? ((adjustedPrice - det.purchase_price) * det.quantity).toFixed(
                    2
                  )
                : 0;

              formattedData.push({
                index: formattedData.length + 1,
                date_formatted: formattedDate,
                date: item.date,
                campu: campusName,
                campu_id: campusId,
                document_name: item.document_name,
                nrm_document: item.nrm_document,
                detail_sale: det.product
                  ? det.product.name
                  : "Producto no encontrado",
                quantity: det.quantity,
                price_sale: det.price,
                price_purchase: det.product
                  ? det.purchase_price
                  : "No disponible",
                profit: productProfit,
              });

              totalProfit += parseFloat(productProfit);
            });
          });

          this.data = formattedData;
          this.countProfit = formattedData.length;
          this.sumaProfit = totalProfit.toFixed(2);
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    clearData() {
      this.data = [];
      this.countProfit = 0;
      this.sumaProfit = 0;
    },
    getColorForCampus(index) {
      const colorKeys = Object.keys(this.coloresSedes);
      const colorKey = colorKeys[index % colorKeys.length];
      return this.coloresSedes[colorKey];
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-container {
  position: relative;
  height: 1000px;
}
</style>